import { JSONContent } from '@tiptap/core';
import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import {
  blue1,
  blue2,
  blue6,
  blue9,
  green1,
  green2,
  green6,
  green9,
  grey1,
  grey10,
  grey2,
  orange1,
  orange2,
  orange6,
  orange9,
  purple1,
  purple2,
  purple6,
  purple9,
  red1,
  red2,
  red6,
  red9,
} from 'approot/shared/styles/colours.style';

export const defaultDimensions = {
  width: 1073,
  height: 605,
};

export type ItemToPreview = {
  itemId: string;
  imageUrl: string;
  altText: string;
  isFit?: boolean;
  text: string | null;
  richtext: JSONContent | null;
  baseColour: string | null;
  audioUrl: string | null;
};

export const MORE_INFO_MAX_CHARS = 240;

export const INTERACTIVE_RICHTEXT_SETTINGS = {
  placeholder: '',
  canBold: true,
  canItalic: true,
  canUnderline: true,
  maxCharacterCount: 60,
};

export const INTERACTIVE_RICHTEXT_EXTENSIONS = getExtensions(
  INTERACTIVE_RICHTEXT_SETTINGS
);

export const COLOUR_GREEN = {
  colour1: green1,
  colour2: green9,
  colour3: green2,
  base: green6,
  name: 'green',
};

export const COLOUR_WHITE = {
  colour1: grey1,
  colour2: grey10,
  colour3: grey2,
  base: grey1,
  name: 'white',
};

export const COLOUR_BLUE = {
  colour1: blue1,
  colour2: blue9,
  colour3: blue2,
  base: blue6,
  name: 'blue',
};

export const COLOUR_PURPLE = {
  colour1: purple1,
  colour2: purple9,
  colour3: purple2,
  base: purple6,
  name: 'purple',
};

export const COLOUR_RED = {
  colour1: red1,
  colour2: red9,
  colour3: red2,
  base: red6,
  name: 'red',
};

export const COLOUR_ORANGE = {
  colour1: orange1,
  colour2: orange9,
  colour3: orange2,
  base: orange6,
  name: 'orange',
};

export const COLOURS = [
  COLOUR_WHITE,
  COLOUR_BLUE,
  COLOUR_PURPLE,
  COLOUR_GREEN,
  COLOUR_RED,
  COLOUR_ORANGE,
];
